import { render, staticRenderFns } from "./CompletedPage.vue?vue&type=template&id=5d8a9b14&"
import script from "./CompletedPage.vue?vue&type=script&lang=js&"
export * from "./CompletedPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports